import React, { Component, Fragment } from 'react'
import { observer } from 'mobx-react'

import Modal from '../../../../UniformComponents/Modal'
import ModalFooter from '../../../../UniformComponents/ModalFooter'
import Button from '../../../../UniformComponents/Button'
import Select from '../../../form/Select'
import Input from '../../../form/Input'

const CASCADE_TREE = {
    label: 'Client level',
    oid: 3,
    children: [
        {
            label: 'Division level',
            oid: 4,
            children: [
                {
                    label: 'Portfolio level',
                    oid: 5,
                    children: [
                        {
                            label: 'Product level',
                            oid: 6,
                            children: [
                                { label: 'Survey level', oid: 7, children: [] },
                            ],
                        },
                    ],
                },
            ],
        },
        { label: 'User level', oid: 11, children: [] },
    ],
}

@observer
class CustomTagGroupEdit extends Component {
    renderLevelNode = (node, depth, isLast, ancestorLines) => {
        const { store } = this.props
        const { tagIdsByOid } = store.groupForm

        return (
            <Fragment key={node.label}>
                <div className="levelTreeRow">
                    {ancestorLines.map(({ label, continues }) => (
                        <span key={label} className={`connectorCol ${continues ? 'line' : ''}`} />
                    ))}
                    {depth > 0 && (
                        <span className={`connectorCol elbow ${isLast ? '' : 'continues'}`} />
                    )}
                    <div className="levelField">
                        <Select
                            label={node.label}
                            options={store.getAvailableAdminTagOptions(node.oid)}
                            value={tagIdsByOid[node.oid]}
                            onBlur={({ value }) => store.setGroupFormTag(node.oid, value)}
                            isClearable
                            blurOnClear
                            placeholder="Select..."
                        />
                    </div>
                </div>
                {node.children.map((child, i, arr) => this.renderLevelNode(
                    child,
                    depth + 1,
                    i === arr.length - 1,
                    depth === 0 ? [] : [...ancestorLines, { label: node.label, continues: !isLast }],
                ))}
            </Fragment>
        )
    }

    render() {
        const { store } = this.props
        const {
            groupModalOpen, groupForm, closeGroupModal, setGroupFormName, toggleGroupFormCascade, saveGroupForm,
        } = store
        const { name, cascade, editingGroupId } = groupForm
        const isEditing = editingGroupId !== undefined

        return (
            <Modal show={groupModalOpen} onClose={closeGroupModal} cssClass="customTagGroupModal">
                <div className="modalHeading">
                    <div className="modalTitle">
                        {isEditing ? `Edit group: ${name}` : 'New custom tag group'}
                    </div>
                </div>

                <Input
                    name="name"
                    label="Name"
                    isMandatory
                    register={store.registerGroupField}
                    unregister={store.unregisterGroupField}
                    defaultValue={name}
                    onBlur={({ value }) => setGroupFormName(value)}
                    emptyError="Group name is required"
                />

                <div className="cascadeRow" onClick={toggleGroupFormCascade} aria-hidden>
                    <div className={`cascadeBox ${cascade ? 'checked' : ''}`}>
                        <i className="fa-solid fa-check" />
                    </div>
                    <span>Visibility cascade</span>
                </div>

                <div className="levelTree">
                    {this.renderLevelNode(CASCADE_TREE, 0, true, [])}
                </div>

                <ModalFooter>
                    <Button
                        label="Cancel"
                        onClick={closeGroupModal}
                        cssClass="regular outline"
                    />
                    <Button
                        label="Save group"
                        onClick={saveGroupForm}
                        cssClass="regular secondary"
                    />
                </ModalFooter>
            </Modal>
        )
    }
}

export default CustomTagGroupEdit
